module.exports = __webpack_public_path__ + "img/chat.62fb9a37.svg";